import React from "react";
import Sidebar from "../../components/commons/Sidebar";
import UserManagement from "../../components/admin/users/UserManagement";

const UsersPage = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-slate-50">
      <Sidebar />
      <UserManagement />
    </div>
  );
};

export default UsersPage;
